"use client"
import StarRating from "@modules/components/star-rating"
import Link from "next/link"
import { useEffect, useState } from "react"
import Scorecardcarousel from "./carousel"
const Datalist = [
  {
    name:1,
    value:2,
  },
  {
    name:1,
    value:2,
  },
  {
    name:1,
    value:2,
  }
]

const ScoreCard = (params) => {
  return (
    <div className="flex h-full flex-col border items-center justify-center rounded-md p-10 lg:min-h-[400px] bg-white">
      <div className="mb-5 w-full lg:min-h-[200px]">
        <Scorecardcarousel className="bg-home-gray_5 rounded" data={Datalist} {...params}/>
      </div>
      <StarRating rating={4} />
      <div className="mt-5 flex items-center justify-center">
        <div className="mr-2 flex items-baseline border-r border-black pr-2">
          <div className="mr-2">TrustScore</div>
          <div className="font-bold">4.6</div>
        </div>
        <div className="flex items-baseline">
          <div className="mr-2 font-bold">6,028</div>
          <div>reviews</div>
        </div>
      </div>
    </div>
  )
}

export default ScoreCard
